import CountUp from 'react-countup';

import { AnimationControls, motion, useAnimation, useScroll, useTransform } from 'framer-motion';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'styles/mobile.css';

import React, { FormEvent, useCallback, useEffect, useRef, useState } from 'react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

import AOS from 'aos';
import 'aos/dist/aos.css';
import { Checkbox, Input, InputTextArea, SelectBox, Text, Label } from 'components';
import LandingFooter from 'components/Landing/LandingFooter';
import LandingHeader from 'components/Landing/LandingHeader';
import SpacecraftScene from 'components/SpacecraftScene/SpacecraftScene';
import { ListType } from 'types/selectbox';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';

import backgroundImg from '../assets/maincontact.jpg';
import RegisterModal from './main/RegisterModal';
import CountrySelector from './ContactUs/CountrySelector';
import TopButton from 'components/TopButton/TopButton';
import Popup from 'components/Popup/Popup';
import FloatingMenu from 'components/FloatingMenu/FloatingMenu';
import { useTranslation } from 'react-i18next';

const Home = () => {
  
  const { t } = useTranslation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [key, setKey] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [breakpoint, setBreakpoint] = useState(false);

  const enquiryOption: ListType[] = [
    { value: 0, label: t('main.contact.form.enquiryOptions.use') },
    { value: 1, label: t('main.contact.form.enquiryOptions.share') },
    { value: 2, label: t('main.contact.form.enquiryOptions.estimate') },
    { value: 3, label: t('main.contact.form.enquiryOptions.press') },
    { value: 4, label: t('main.contact.form.enquiryOptions.other') }
  ];

  const [enquiry, setEnquiry] = useState(1);
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [country, setCountry] = useState<any>(null);
  const [contactInfo, setContactInfo] = useState('');
  const [enqiryContents, setEnqiryContents] = useState('');
  const [isAgree, setIsAgree] = useState<boolean>(false);
  const [isRegisterModalOpened, setIsRegisterModalOpened] = useState<boolean>(false);
  const [features, setFeatures] = useState(0);

  const { scrollY } = useScroll();
  const scale = useTransform(scrollY, [0, 3000], [1, 4]);
  const controls = useAnimation();
  const benefitsSectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: benefitsSectionRef,
    offset: ['start end', 'end start']
  });

  const y = useTransform(scrollYProgress, [0, 1], [0, -40]);
  const rotateX = useTransform(scrollYProgress, [0, 1], [30, -15]);
  const scale2 = useTransform(scrollYProgress, [0, 1], [0.8, 1]);
  const opacity = useTransform(scrollYProgress, [0, 0.5, 1], [0.3, 0.8, 1]);

    // AOS 초기화
  useEffect(() => {
    AOS.init();
  }, []);

const popupInitialized = useRef(false);

// useEffect(() => {
//   if (popupInitialized.current) return;
//   popupInitialized.current = true;

//   const shown = sessionStorage.getItem('popupShown');
//   if (!shown) {
//     const timer = setTimeout(() => {
//       setIsPopupOpen(true);
//     }, 1000);
//     sessionStorage.setItem('popupShown', 'true'); 
//     return () => clearTimeout(timer);
//   }
// }, []);


  // 이 시점에만 세션 저장
  const handlePopupClose = useCallback(() => {
  sessionStorage.setItem('popupShown', 'true');
  setIsPopupOpen(false);
}, []);


  useEffect(() => {
    const handleScroll = () => setScrollPosition(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (scrollPosition > 3300) {
      setBreakpoint(true);
    } else {
      setBreakpoint(false);
    }
  }, [scrollPosition]);

  useEffect(() => {
    const handleScroll = (): void => {
      const scrollY: number = window.scrollY;
      const windowHeight: number = window.innerHeight;
      const sectionElement = document.querySelector('.benefits-section');

      if (sectionElement) {
        const sectionTop: number = sectionElement.getBoundingClientRect().top + scrollY;
        const sectionHeight: number = sectionElement.clientHeight;
        const sectionProgress: number = (scrollY - sectionTop + windowHeight) / (sectionHeight + windowHeight);
        const rotateX: number = 60 * (1 - Math.min(Math.max(sectionProgress, 0), 1));
        controls.start({ rotateX });
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [controls]);

  useEffect(() => {
    const interval = setInterval(() => {
      setKey((prevKey) => prevKey + 1);
    }, 2800);
    return () => clearInterval(interval);
  }, []);

  const [threePosition, setThreePosition] = useState({ x: -20, y: 10 });

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const newX = Math.min(-20 + scrollY / 10, 0);
      const newY = Math.min(10 + scrollY / 10, 30);
      setThreePosition({ x: newX, y: newY });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function onSubmit(e: React.FormEvent) {
    e.preventDefault();
  }

  function onCheck(value: boolean) {
    setIsAgree(value);
  }

  async function onSave() {
    if (!isAgree) {
      setIsRegisterModalOpened(true);
      return;
    }

    const params = {
      writerEmail: contactInfo,
      writerName: name,
      inquiryType: enquiry,
      inquiryContents: enqiryContents,
      organization: company,
      country: country.label,
      isAgreePrivacy: isAgree,
    }
    const res = await axios.post('/api/contactUs/register', params);

    // Form reset
    setEnquiry(1);
    setName('');
    setCompany('');
    setCountry(null);
    setEnqiryContents('');
    setContactInfo('');
    setIsAgree(false);
  }

  function handleModalConfirm() {
    setIsAgree(true);
    setIsRegisterModalOpened(false);
  }


  return (
    <>
      <Helmet>
        <title>IOPS SPACE - Your Gateway to Space | Satellite Communication & Ground Station Services</title>
        <meta name="description" content="IOPS SPACE provides cutting-edge satellite communication services, ground station solutions, and space mission support. Connect with satellites, manage spacecraft operations, and access reliable space infrastructure." />
        <meta name="keywords" content="아이옵스스페이스, 아이옵스, iopsspace, iops space, iops, satellite communication, ground station, spacecraft operations, satellite tracking, space mission support, satellite services, space infrastructure, satellite management, space technology, satellite operations, satellite ground station, space communication, satellite mission control, spacecraft tracking, satellite data services, space operations, satellite network, ground station network, satellite communication infrastructure, space mission planning, satellite operations center, ground station services, satellite communication solutions, space technology services, satellite ground segment, space mission support services" />
        <meta name="author" content="IOPS SPACE" />
        <meta name="robots" content="index, follow" />
        
        {/* Additional SEO Meta Tags */}
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="theme-color" content="#000000" />
        <link rel="canonical" href="https://iopsspace.com/" />
        
        {/* Structured Data for Organization */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "IOPS SPACE",
            "url": "https://iopsspace.com",
            "logo": "https://iopsspace.com/logo.svg",
            "description": "Leading provider of satellite communication services and ground station solutions",
            "address": {
              "@type": "PostalAddress",
              "addressCountry": "KR"
            },
            "sameAs": [
              "https://x.com/IOPS_SPACE",
              "https://www.linkedin.com/company/i-ops"
            ]
          })}
        </script>
      </Helmet>
      
      <div className="overflow-x-hidden bg-black">
        <TopButton />
        <FloatingMenu/>
        <LandingHeader breakpoint={breakpoint} />
    <div id="hero" className="relative z-0 h-screen overflow-visible">
      <div className="relative h-screen overflow-visible">
        <div className="z-0 flex h-full w-full items-end justify-end">
          <motion.div
            style={{
              backgroundImage: `url('/bg.avif')`,
              mask: 'linear-gradient(180deg, rgb(0, 0, 0) 65%, rgba(0, 0, 0, 0) 100%)',
              zIndex: -1,
              objectFit: 'cover',
              objectPosition: 'center',
              backgroundSize: 'cover',
              backgroundPosition: 'top -100vh bottom',
              width: '100%',
              height: '120%',
              scale: scale,
              y: y,
              overflowClipMargin: 'content-box',
              overflow: 'clip'
            }}
          />
        </div>
        <div className="absolute top-0 h-screen w-full">
          <div
            style={{
              position: 'relative',
              right: '-20%',
              top: '10%'
            }}
          >
            <SpacecraftScene />
          </div>
        </div>

        <div className="absolute left-1/2 top-0 z-1 flex h-full w-full translate-x-[-50%] flex-col items-center justify-center px-5 pt-[74px] z-1">
          <div className="flex flex-col items-center gap-2 text-center text-white">
            <h1 data-aos="fade-up" className="text-[40px] font-bold md:text-[80px] xl:text-[100px]">
              YOUR GATEWAY TO SPACE
            </h1>
            <p data-aos="zoom-in" data-aos-delay="500" className="font-semibold md:text-[22px] xl:text-2xl">
              IS HERE
            </p>
            <div data-aos="zoom-in" data-aos-delay="500" className="h-[2px] w-6 bg-white bg-opacity-25"></div>
            <p data-aos="zoom-in" data-aos-delay="500" className="text-base font-regular xl:text-lg">
              {t('main.missionSupport1')} <br/> {t('main.missionSupport2')}
            </p>
            <Link to="/get-started">
              <button
                data-aos="zoom-in"
                data-aos-delay="800"
                className="mt-10 rounded-lg bg-white px-4 py-2 font-medium text-black cursor-pointer"
              >
                {t('main.getStarted')}
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>

    <div id="overview" className="z-10 transform px-5 py-[320px] text-white">
      <div className="mx-auto hidden max-w-[1400px] flex-col gap-16 lg:flex">
        <div data-aos="fade-up" className="flex flex-col gap-2">
          <h2 className="md:text-base xl:text-lg">
            {t('main.overview.sectionTitle')}
          </h2>
          <h3 className="font-semibold md:text-[40px] xl:text-[48px]">
            {t('main.overview.sectionSubtitle')}
          </h3>
        </div>
        <div className="grid grid-cols-3 gap-4">
          <div className="bg-custom">
            <div
              data-aos="fade-up"
              className="flex aspect-[1.18] flex-col break-keep rounded-2xl bg-cover bg-center p-6 md:min-h-[254px] md:min-w-[300px]"
              style={{
                backgroundImage: `linear-gradient(to top, rgba(0,0,0,1), rgba(0,0,0,0)), url('/card/1.jpg')`
              }}
            >
              <div className="flex h-full flex-col justify-end gap-2">
                <h4 className="font-semibold md:text-[22px] xl:text-2xl">
                  {t('main.overview.card1Title')}
                </h4>
                <p className="md:text-base xl:text-lg">
                  {t('main.overview.card1Desc')}
                </p>
              </div>
            </div>
          </div>

          <div
            data-aos="fade-up"
            className="flex aspect-[1.18] flex-col break-keep rounded-2xl bg-cover bg-center p-6 md:min-h-[254px] md:min-w-[300px]"
            style={{
              backgroundImage: `linear-gradient(to top, rgba(0,0,0,1), rgba(0,0,0,0)), url('/card/2.avif')`
            }}
          >
            <div className="flex h-full flex-col justify-end gap-2">
              <h4 className="font-semibold md:text-[22px] xl:text-2xl">
                {t('main.overview.card2Title')}
              </h4>
              <p className="md:text-base xl:text-lg">
                {t('main.overview.card2Desc')}
              </p>
            </div>
          </div>

          <div
            data-aos="fade-up"
            className="flex aspect-[1.18] flex-col break-keep rounded-2xl bg-cover bg-center p-6 md:min-h-[254px] md:min-w-[300px]"
            style={{
              backgroundImage: `linear-gradient(to top, rgba(0,0,0,1), rgba(0,0,0,0)), url('/card/3.webp')`
            }}
          >
            <div className="flex h-full flex-col justify-end gap-2">
              <h4 className="font-semibold md:text-[22px] xl:text-2xl">
                {t('main.overview.card3Title')}
              </h4>
              <p className="md:text-base xl:text-lg">
                {t('main.overview.card3Desc')}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto flex max-w-[1400px] flex-col gap-16 lg:hidden">
        <div data-aos="fade-up" className="flex flex-col gap-2">
          <h2 className="md:text-base xl:text-lg">Overview</h2>
          <h3 className="text-[34px] font-semibold md:text-[40px] xl:text-[48px]">
            All-in-one solution for Spacecraft
          </h3>
        </div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="bg-custom z-50">
            <div
              data-aos="fade-up"
              className="flex aspect-[1.18] flex-col break-keep rounded-2xl bg-cover bg-center p-6 md:min-h-[254px] md:min-w-[300px]"
              style={{
                backgroundImage: `linear-gradient(to top, rgba(0,0,0,1), rgba(0,0,0,0)), url('/card/1.jpg')`
              }}
            >
              <div className="flex h-full flex-col justify-end gap-2">
                <h4 className="text-[22px] font-semibold xl:text-2xl">ORBITAL SCHEDULING</h4>
                <p className="md:text-base xl:text-lg">
                  Satellite orbit prediction and ground station contact scheduling
                </p>
              </div>
            </div>
          </div>

          <div
            data-aos="fade-up"
            className="flex aspect-[1.18] flex-col break-keep rounded-2xl bg-cover bg-center p-6 md:min-h-[254px] md:min-w-[300px]"
            style={{
              backgroundImage: `linear-gradient(to top, rgba(0,0,0,1), rgba(0,0,0,0)), url('/card/2.avif')`
            }}
          >
            <div className="flex h-full flex-col justify-end gap-2">
              <h4 className="text-[22px] font-semibold xl:text-2xl">MISSION CONTROL</h4>
              <p className="md:text-base xl:text-lg">
                Real-time tracking of satellites along orbital paths and AI-based mission control
              </p>
            </div>
          </div>
        </div>
        <div className="grid w-full grid-cols-1">
          <div
            data-aos="fade-up"
            className="flex aspect-[1.18] flex-col break-keep rounded-2xl bg-cover bg-center p-6 md:min-h-[254px] md:min-w-[300px]"
            style={{
              backgroundImage: `linear-gradient(to top, rgba(0,0,1), rgba(0,0,0,0)), url('/card/3.webp')`
            }}
          >
            <div className="flex h-full flex-col justify-end gap-2">
              <h4 className="text-[22px] font-semibold xl:text-2xl">CONTRIBUTE</h4>
              <p className="md:text-base xl:text-lg">Provide processing and analysis solution based on requests</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className={`${breakpoint ? 'bg-white' : 'bg-black'} transform px-5 py-[320px] text-white transition-all duration-500`}>
      <div data-aos="fade-up" className="mx-auto max-w-[1400px]">
        <Swiper
          loop={true}
          pagination={{
            clickable: true
          }}
          autoplay={{
            delay: 5000
          }}
          navigation={true}
          modules={[Pagination, Navigation, Autoplay]}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className="flex flex-col gap-16 pb-32">
              <div className="flex flex-col gap-4">
                <p className="text-[34px] font-semibold md:text-[40px] xl:text-[48px]">
                  {t('main.slider.slide1.title')}
                </p>
                <p className="md:text-base xl:text-lg">
                  {t('main.slider.slide1.desc')}
                </p>
              </div>
              <div className="grid grid-cols-3 main-swiper">
                <div className="flex flex-col py-10 text-center">
                  <p className="text-[72px] font-semibold txt-sm">
                    <CountUp key={key} start={0} end={28} duration={2.75} />
                  </p>
                  <p className="p-txt">
                    {t('main.slider.slide1.stat1.line1')} <br />
                    {t('main.slider.slide1.stat1.line2')}
                  </p>
                </div>

                <div className="flex flex-col py-10 text-center">
                  <p className="text-[72px] font-semibold txt-sm">
                    <CountUp key={key} start={0} end={17} duration={2.75} />
                  </p>
                  <p className="p-txt">
                    {t('main.slider.slide1.stat2.line1')} <br />
                    {t('main.slider.slide1.stat2.line2')}
                  </p>
                </div>

                <div className="flex flex-col py-10 text-center">
                  <p className="text-[72px] font-semibold txt-sm">
                    <CountUp key={key} start={0} end={8} duration={2.75} />
                  </p>
                  <p className="p-txt">
                    {t('main.slider.slide1.stat3.line1')} <br />
                    {t('main.slider.slide1.stat3.line2')}
                  </p>
                </div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="flex h-full w-full flex-col gap-16 pb-32">
              <div className="flex flex-col gap-4">
                <p className="text-[34px] font-semibold md:text-[40px] xl:text-[48px]">
                  {t('main.slider.slide2.title')}
                </p>
                <p className="md:text-base xl:text-lg">
                  {t('main.slider.slide2.desc')}
                </p>
              </div>
              <img src="/slider/1.png" alt="first slider img" />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="flex h-full w-full flex-col gap-16 pb-32">
              <div className="flex flex-col gap-4">
                <p className="text-[34px] font-semibold md:text-[40px] xl:text-[48px]">
                  {t('main.slider.slide3.title')}
                </p>
                <p className="md:text-base xl:text-lg">
                  {t('main.slider.slide3.desc')}
                </p>
              </div>
              <img src="/slider/2.png" alt="second slider img" />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>

    <div
      id="benefits"
      className="bg-white benefits-section transform px-5 py-[320px] text-black transition-all duration-500"
      ref={benefitsSectionRef}
    >
      <div className="mx-auto flex max-w-[1400px] flex-col gap-20">
        <div data-aos="fade-up">
          <p className="text-lg">
            {t('main.benefits.sectionTitle')}
          </p>
          <p className="text-[34px] font-semibold md:text-[40px] xl:text-[48px]">
            {t('main.benefits.sectionSubtitle')}
          </p>
        </div>
        <motion.div>
          <motion.div
            style={{
              rotateX,
              scale: scale2,
              opacity
            }}
          >
            <img className="w-full rounded-lg shadow-lg" src="/thirdSection/1.avif" alt="Benefits illustration" />
          </motion.div>
        </motion.div>

        <div className="grid lg:grid-cols-2 xl:grid-cols-3">
          <div data-aos="fade-up" className="flex flex-col items-center p-4 text-center">
            <img src="/icon/box.svg" alt="box icon" />
            <p className="mt-3 font-semibold md:text-lg xl:text-xl">
              {t('main.benefits.card1.title')}
            </p>
            <p className="mt-2 text-sm text-[#6b6b6b]">
              {t('main.benefits.card1.desc')}
            </p>
          </div>

          <div data-aos="fade-up" className="flex flex-col items-center p-4 text-center">
            <img src="/icon/clock.svg" alt="clock icon" />
            <p className="mt-3 font-semibold md:text-lg xl:text-xl">
              {t('main.benefits.card2.title')}
            </p>
            <p className="mt-2 text-sm text-[#6b6b6b]">
              {t('main.benefits.card2.desc')}
            </p>
          </div>

          <div data-aos="fade-up" className="flex flex-col items-center p-4 text-center">
            <img src="/icon/server.svg" alt="server icon" />
            <p className="mt-3 font-semibold md:text-lg xl:text-xl">
              {t('main.benefits.card3.title')}
            </p>
            <p className="mt-2 text-sm text-[#6b6b6b]">
              {t('main.benefits.card3.desc')}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div id="features" className="bg-[#f5f5f5] px-5 py-[320px]">
      <div className="mx-auto max-w-[1400px]">
        <div data-aos="fade-up" className="flex flex-col gap-1">
          <p className="lg:text-base xl:text-lg">
            {t('main.features.sectionTitle')}
          </p>
          <p className="text-[34px] font-semibold md:text-[40px] xl:text-[48px]">
            {t('main.features.sectionSubtitle')}
          </p>
        </div>
        <div data-aos="fade-up" className="mt-20 grid grid-cols-2 md:grid-cols-4">
          <button
            onMouseOver={() => {
              setFeatures(0);
            }}
            className={`${features === 0 ? 'bg-[#e6e6e6]' : ''} flex flex-col gap-1 rounded-lg p-6 text-left`}
          >
            <p className={`${features === 0 ? 'text-black' : 'text-[#b9b9b9]'} text-lg font-semibold xl:text-xl`}>
              {t('main.features.steps.getStarted.title')}
            </p>
            <p className={`${features === 0 ? 'text-[#6b6b6b]' : 'text-[#bebebe]'} text-sm xl:text-base`}>
              {t('main.features.steps.getStarted.desc')}
            </p>
          </button>
          <button
            onMouseOver={() => {
              setFeatures(1);
            }}
            className={`${features === 1 ? 'bg-[#e6e6e6]' : ''} flex flex-col gap-1 rounded-lg p-6 text-left`}
          >
            <p className={`${features === 1 ? 'text-black' : 'text-[#b9b9b9]'} text-lg font-semibold xl:text-xl`}>
              {t('main.features.steps.manageSpacecraft.title')}
            </p>
            <p className={`${features === 1 ? 'text-[#6b6b6b]' : 'text-[#bebebe]'} text-sm xl:text-base`}>
              {t('main.features.steps.manageSpacecraft.desc')}
            </p>
          </button>
          <button
            onMouseOver={() => {
              setFeatures(2);
            }}
            className={`${features === 2 ? 'bg-[#e6e6e6]' : ''} flex flex-col gap-1 rounded-lg p-6 text-left`}
          >
            <p className={`${features === 2 ? 'text-black' : 'text-[#b9b9b9]'} text-lg font-semibold xl:text-xl`}>
              {t('main.features.steps.contactProfile.title')}
            </p>
            <p className={`${features === 2 ? 'text-[#6b6b6b]' : 'text-[#bebebe]'} text-sm xl:text-base`}>
              {t('main.features.steps.contactProfile.desc')}
            </p>
          </button>
          <button
            onMouseOver={() => {
              setFeatures(3);
            }}
            className={`${features === 3 ? 'bg-[#e6e6e6]' : ''} flex flex-col gap-1 rounded-lg p-6 text-left`}
          >
            <p className={`${features === 3 ? 'text-black' : 'text-[#b9b9b9]'} text-lg font-semibold xl:text-xl`}>
              {t('main.features.steps.scheduleContact.title')}
            </p>
            <p className={`${features === 3 ? 'text-[#6b6b6b]' : 'text-[#bebebe]'} text-sm xl:text-base`}>
              {t('main.features.steps.scheduleContact.desc')}
            </p>
          </button>
        </div>
        <img
          data-aos="fade-up"
          className="shadow-custom mt-4 rounded-lg"
          src={`/features/${features}.webp`}
          alt={features + 'qwd'}
        />
      </div>
    </div>

    <div id="contact" className="bg-white px-5 py-[320px]">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-10 xl:grid-cols-2">
        <div className="w-full">
          <p data-aos="fade-up">
            {t('main.contact.sectionTitle')}
          </p>
          <p data-aos="fade-up" className="mt-1 text-[34px] font-semibold md:text-[40px] xl:text-[48px]">
            {t('main.contact.sectionSubtitle')}
          </p>
          <form data-aos="fade-up" className="mt-20 flex w-full flex-col gap-5 lg:max-w-[480px]" onSubmit={onSubmit}>
            <label className="w-full">
              <SelectBox
                className="max-w-none"
                bgColor="layer3"
                label={t('main.contact.form.enquiryType')}
                list={enquiryOption}
                value={enquiry}
                setValue={setEnquiry}
              />
            </label>
            <label className="w-full">
              <Input 
                className="" 
                placeholder={t('main.contact.form.namePlaceholder')} 
                label={t('main.contact.form.name')} 
                value={name} 
                setValue={setName} 
              />
            </label>

            <label className="w-full">
              <Input
                className=""
                placeholder={t('main.contact.form.companyPlaceholder')}
                label={t('main.contact.form.company')}
                value={company}
                setValue={setCompany}
              />
            </label>

            <label className="w-full">
              <p className="text-[12px] text-[#6b6b6b]"></p>
              <Input
                className=""
                placeholder={t('main.contact.form.emailPlaceholder')}
                label={t('main.contact.form.email')}
                value={contactInfo}
                setValue={setContactInfo}
              />
            </label>

            <label className="w-full">
            <Label
              label={t('main.contact.form.country')}
              htmlFor={'Country'}
            />
            <CountrySelector className="max-w-none" value={country} onChange={setCountry} /> 
            </label>

            <label className="w-full">
              <InputTextArea
                className="h-32 "
                label={t('main.contact.form.inquiry')}
                value={enqiryContents}
                setValue={setEnqiryContents}
              />
            </label>

            <div className="flex flex-row items-center gap-2">
              <Checkbox value={isAgree} onChange={onCheck} inputKey="agree" />
              <Text size="body2" weight="regular" color="secondary">
                {t('main.contact.form.agree')}
              </Text>
            </div>

            <button className="xl: transform rounded-md bg-black py-2 text-sm font-medium text-white transition-all duration-500 hover:bg-[#333333]" onClick={onSave}>
              {t('main.contact.form.submit')}
            </button>
          </form>
        </div>
        <div
          data-aos="fade-up"
          className="hidden w-full rounded-2xl bg-cover bg-center xl:block"
          style={{
            backgroundImage: `url(${backgroundImg})`
          }}
        ></div>
      </div>
      <RegisterModal isOpened={isRegisterModalOpened} setIsOpened={setIsRegisterModalOpened} onConfirm={handleModalConfirm} />
        </div>
        <LandingFooter />
        {/* <Popup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} /> */}
        {/* {isPopupOpen && (
          <Popup isOpen={true} onClose={handlePopupClose} />
        )} */}
      </div>
    </>
  );
};

export default Home;
